import axios from '@/axios'

const Invitefriends = {
  //获取首页活动数据
  async getMyActivity(params) {
    return await axios.post('/uc/oldLeadNewActivity/getMyActivity', params , { des: '直客pc获取账老带新活动主页内容', sTime: new Date().getTime() }) 
  },
  //邀请奖励 
  async getInviteReward(params) {
    return await axios.post('/uc/oldLeadNewActivity/getInviteReward', params , { des: '直客pc获取被邀请奖励数据', sTime: new Date().getTime() }) 
  },
   //活动奖励 邀请奖励详情 
  
  async getBeInviteRewardInfo(params) {
    return await axios.post('/uc/oldLeadNewActivity/getBeInviteRewardInfo', params , { des: '直客pc获取奖励详情', sTime: new Date().getTime() }) 
  },

  //查询被邀请奖励 

  async getBeInviteReward(params) {
    return await axios.post('/uc/oldLeadNewActivity/getBeInviteReward', params , { des: '直客pc获取被邀请奖励详情', sTime: new Date().getTime() }) 
  },

  //结算记录 

  async getSettlementRecord(params) {
    return await axios.post('/uc/oldLeadNewActivity/getSettlementRecord', params , { des: '直客pc获取结算记录', sTime: new Date().getTime() }) 
  },

  //绑定邀请码 
  async BindingAgentId(params) {
    return await axios.post('/uc/oldLeadNewActivity/getBindingAgentId', params , { des: '直客pc绑定邀请码', sTime: new Date().getTime() }) 
  },


}

export default Invitefriends


// WEBPACK FOOTER //
// ./src/api/Invitefriends.js